import { without } from "lodash-es";
import React from "react";
import type { ItemType } from "../../../../clients/graphqlTypes.js";
import { FilterChip } from "../../../commons/filters/FilterChip.js";
import { useItemTypes } from "../hooks/useItemTypes.js";

interface Props {
  label?: string;
  value: ItemType[] | null | undefined;
  setValue: (newValue: ItemType[] | null | undefined) => void;
}

export const ItemTypeChips = ({ label, value, setValue }: Props) => {
  const { itemTypeOptions, itemTypeLabels } = useItemTypes();
  const getValueLabel = React.useCallback(
    (value: ItemType) => itemTypeLabels[value],
    [itemTypeLabels]
  );
  return (
    <>
      {itemTypeOptions
        .filter(o => value && value.includes(o.value))
        .map(itemType => (
          <FilterChip
            key={itemType.value}
            label={label}
            onDelete={() => {
              const newValue = without(value, itemType.value);
              setValue(newValue.length > 0 ? newValue : undefined);
            }}
            value={itemType.value}
            getValueLabel={getValueLabel}
          />
        ))}
    </>
  );
};
